import React from 'react'
import TopBar from '../components/menu/TopBar'
import ReactWizard from '../components/wizard/ReactWizard'
import PayableTo from '../components/claimintake/PayableTo'
import Signature from '../components/claimintake/Signature'
import { useSelector } from 'react-redux'
import { language } from '../stores/slices/languageSlice'
import UploadDocuments from '../components/claimintake/UploadDocuments'
import AppintakeCard from '../components/appintake/AppintakeCard'

function ClaimIntake() {
    const selectedLanguage = useSelector(language).Wizard

    const Tabs = [
        { label: selectedLanguage.claimintake.payableTo, component: <PayableTo />, isSubTab: false },
        { label: selectedLanguage.claimintake.documents, component: <UploadDocuments />, isSubTab: false },
        { label: selectedLanguage.claimintake.signature, component: <Signature />, isSubTab: false },
    ]

    return (
        <div className="content">
            <TopBar />
            <AppintakeCard flow={{flow:'Claim'}} />
            <div className="intro-y box py-10 d-flex justify-content-center py-sm-20">
                <ReactWizard Tabs={Tabs} finishButtonText={"Submit"} />
            </div>
        </div>
    )
}

export default ClaimIntake